export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4765.66a7cbcc.jpg";